import PropTypes from 'prop-types';
import React from 'react';
import ImageWithSpinner from '../ImageWithSpinner';
import styles from './Carousel.css';

class Carousel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeImageIdx: 0,
    };
  }

  render() {
    // const timeInterval = 3 // 3 seconds
    // setTimeout(this.renderImage, timeInterval * 1000)

    return (
      <div className={`${this.props.wrapperClassName}`}>
        <div className={`row ${styles.containerWrapper}`}>
          <div className={styles.imageWrapper}>
            {this._renderImage(
              this.props.images[this.state.activeImageIdx],
              this.state.activeImageIdx
            )}
          </div>
        </div>

        <div className={styles.imgSelectionContainer}>
          {this.props.images.map((img, i) => (
            <img
              key={i}
              className={this.isSelected(i)}
              src={img}
              onClick={() => this.showImage(i)}
            />
          ))}
        </div>
      </div>
    );
  }

  renderImage = () => {
    if (this.state.activeImageIdx === this.props.images.length - 1) {
      this.setState({ activeImageIdx: 0 });
    } else {
      this.setState({ activeImageIdx: this.state.activeImageIdx + 1 });
    }
    return this.showImage(this.state.activeImageIdx);
  };

  showImage = id => {
    this.setState({ activeImageIdx: id });
  };

  isSelected = id => {
    if (this.state.activeImageIdx === id) {
      return styles.selected;
    }
    return '';
  };

  _renderImage = (image, idx) => {
    return (
      <a href={image} className={styles.image} target={'_blank'}>
        <ImageWithSpinner
          image={image}
          wrapperClassName={styles.image}
          imageClassName={styles.image}
          show={idx === this.state.activeImageIdx}
        />
      </a>
    );
  };

  _renderOption = (image, idx) => {
    let className;
    if (idx === this.state.activeImageIdx) {
      className = 'fa fa-circle';
    } else {
      className = 'fa fa-circle-thin';
    }
    return (
      <span
        className={`${className} ${styles.option}`}
        onClick={() => this._onClickCircle(idx)}
      />
    );
  };

  _onClickCircle = idx => {
    this.setState({ activeImageIdx: idx });
  };

  _onClickPrevious = () => {
    const nimages = this.props.images.length;
    const { activeImageIdx } = this.state;
    if (activeImageIdx === 0) {
      this.setState({ activeImageIdx: nimages - 1 });
    } else {
      this.setState({ activeImageIdx: activeImageIdx - 1 });
    }
  };

  _onClickNext = () => {
    const nimages = this.props.images.length;
    const { activeImageIdx } = this.state;
    this.setState({ activeImageIdx: (activeImageIdx + 1) % nimages });
  };
}

Carousel.propTypes = {
  wrapperClassName: PropTypes.string,
  images: PropTypes.array,
};

Carousel.defaultProps = {
  height: '500px',
  wrapperClassName: styles.wrapper,
};

export default Carousel;
